// SPDX-License-Identifier: Apache-2.0
import GirafeHTMLElement from '../../base/GirafeHTMLElement';
import GirafeSingleton from '../../base/GirafeSingleton';

type Callback = (elem: GirafeHTMLElement) => unknown;
type Constructor<T> = new (...args: unknown[]) => T;

export default class ComponentManager extends GirafeSingleton {
  private readonly components: { [tagName: string]: GirafeHTMLElement[] } = {};
  private readonly registeredCallbacks: Callback[][] = [];
  private readonly registeredCallbacksClasses: Constructor<GirafeHTMLElement>[] = [];

  public registerComponent(component: GirafeHTMLElement) {
    this.components[component.name] ??= [];
    this.components[component.name].push(component);

    for (let i = 0; i < this.registeredCallbacksClasses.length; i++) {
      if (component instanceof this.registeredCallbacksClasses[i]) {
        this.registeredCallbacks[i].forEach((callback) => callback(component));
      }
    }
  }

  public registerComponentCallback(component: Constructor<GirafeHTMLElement>, callback: Callback) {
    this.registeredCallbacksClasses.push(component);
    this.registeredCallbacks.push([callback]);
  }

  public getComponents<T extends GirafeHTMLElement>(type: Constructor<T>): T[] {
    return Object.values(this.components)
      .flat()
      .filter((c) => c instanceof type) as T[];
  }

  public getComponentsByName(name: string) {
    return this.components[name];
  }
}
